export default "/assets/weekly-photos-block-male-placeholder.png";